var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_DISCOUNT_CODES = 'api/v2/discountCodes';
const GET_SET_AUTOMATIC_DISCOUNTS = 'api/discounts';
export const createAutomaticDiscount = function (storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_AUTOMATIC_DISCOUNTS}/${storeId}`, data, config);
        }
        catch (error) {
            console.error('Error fetching createAutomaticDiscount:', error);
            throw error;
        }
    });
};
export const createDiscountCode = function (storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_DISCOUNT_CODES}/${storeId}`, data, config);
        }
        catch (error) {
            console.error('Error fetching createAutomaticDiscount:', error);
            throw error;
        }
    });
};
